import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';
import miniToastr from "mini-toastr";

export const functions_quota = {
    mixins: [functions],
    data: function () {
        return {
            reports:[],
            hquotas:[],
            quota:null,
        }
    },

    methods: {
        loadHquotas: function (hotel_id, onSuccess=null, param=null) {
            if (!this.isHquotasLoaded()) {
                this.hquotas = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/quotas')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.hquotas = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
        },

        resetHquotas: function () {
            this.hquotas = [];
            return this;
        },

        isHquotasLoaded: function () {
            return this.is(this.hquotas) && this.hquotas.length;
        },

        loadQuota: function (quota_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('quota/' + quota_id)).then(function (response) {
                response = this.httpSuccess(response);
                this.quota = response.payload;
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },


        addQuota: function (onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('quota/create/' + this.hotel_id)).then(function (response) {
                response = this.httpSuccess(response);
                miniToastr["info"]('Квота добавлена', null, CONSTANTS.TOAST_INFO_LIFETIME);
                this.hquotas.push(response.payload);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

        enableQuota(quota, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('quota/' + quota.id + '/enable')).then(function (response) {
                response = this.httpSuccess(response);
                quota.m_disabled = false;
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Квота включена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError);
        },

        disableQuota(quota, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('quota/' + quota.id + '/disable')).then(function (response) {
                response = this.httpSuccess(response);
                quota.m_disabled = true;
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Квота отключена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError);
        },

        cloneQuota: function (quota, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('quota/' + quota.id + '/clone')).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    this.hquotas.push(response.payload);
                    this.editQuota(response.payload);
                }
                else {
                    this.error_log(response.error);
                }
            }, this.httpError);
        },

        deleteQuota: function (quota, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('quota/' + quota.id + '/delete')).then(function (response) {
                response = this.httpSuccess(response);
                if (response.result === 'success') {
                    console.log(response);
                    let index = this.hquotas.indexOf(quota);
                    if (index !== -1) {
                        this.hquotas.splice(index, 1);
                    }
                }
                else {
                    this.error_log(response.error);
                }
            }, this.httpError);
        },

        saveQuota: function (onSuccess = null, param = null) {
            this.latest = this.quota.id;
            this.httpPrepare();
            this.$http.put(this.apiurl('quota/' + this.quota.id + '/save'),  this.quota ).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["info"]('Квота сохранена', null, CONSTANTS.TOAST_INFO_LIFETIME);
            }, this.httpError);
        },
    },
}
